<template>
    <div class="bg-white py-2 px-8">

        <div class="flex justify-between items-center">

            <div class="flex items-center gap-4">
                <HeaderMainMobileMenu />
                <HeaderMainMobileSearch />
            </div>

            <nuxt-link to="/">
                <Logo
                    class="h-10"
                />
            </nuxt-link>

            <div class="flex items-center justify-end gap-2">
                <button @click="handleFavouriteClick">
                    <FavouriteIcon class="h-6 w-6" />
                </button>
                <HeaderMainMobileBasket />
            </div>
        </div>
    </div>
</template>

<script>
import HeaderMainMobileSearch from '~/components/HeaderMainMobileSearch';
import HeaderMainMobileMenu from '~/components/HeaderMainMobileMenu';
import HeaderMainMobileBasket from '~/components/HeaderMainMobileBasket';
import HeaderMainMobileAccount from '~/components/HeaderMainMobileAccount';
import FavouriteIcon from '~/static/images/favourite.svg';
import Logo from '~/static/images/logo.svg';

export default {

    components: {
        HeaderMainMobileSearch,
        HeaderMainMobileMenu,
        HeaderMainMobileBasket,
        HeaderMainMobileAccount,
        FavouriteIcon,
        Logo,
    },

    methods: {
        async handleFavouriteClick() {
            if (!this.$store.getters['user/isLoggedIn']) {
                this.$modal.show('auth-modal');
                return;
            }

            await this.$router.push('/account/favourites');
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
